module.exports = __webpack_public_path__ + "img/388.9f6d1635.png";